module.exports = __webpack_public_path__ + "media/innovation.5524fb71.mp4";